import jsPDF from "jspdf";
import moment from "moment";
import employeeLogo from "../../images/employee.png";
import { convertToRFT } from "../../utils/convertToRFT";
import Arabic from "../../images/arabic title.png";
import address from "../../images/arabic address.png";

function ChallanPrint({ items, search }) {
  let companyCode = localStorage.getItem("companyCode");
  let doc = new jsPDF();
  let customer = "";
  if (search.customerInfo) {
    customer = search.customerInfo;
  } else if (search.ledger) {
    customer = search.ledger?.name;
  } else if (search.vendor) {
    customer = search.vendor?.companyName;
  }

  doc.setFontSize(10);
  doc.setFontSize(18);
  if (companyCode == 4971 || companyCode == 1178) {
    let title = new Image();
    title.src = Arabic;
    doc.addImage(title, "png", 50, 6, 150, 20);
  } else {
    doc.text(localStorage.getItem("company"), 50, 22);
  }
  doc.setFontStyle("normal");

  doc.setFontSize(26);

  doc.setFontSize(12);
  doc.setFontStyle("normal");

  doc.text("Date", 150, 53);
  doc.text(moment().format("DD-MM-YYYY"), 165, 53);

  doc.setFontSize(16);
  doc.text("Customer", 122, 61);
  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(customer, 122, 68);

  doc.setFontSize(12);
  doc.text("Shop", 20, 52);

  doc.setFontStyle("normal");
  if (companyCode == 4971 || companyCode == 117) {
    let title = new Image();
    title.src = address;
    doc.text("Darb public street next to Abu Qarn Station", 20, 65);
    doc.addImage(title, "png", 20, 66, 80, 5);
    doc.text(localStorage.getItem("phone") || "", 20, 80);
  } else {
    doc.text(localStorage.getItem("company") || "", 20, 58);
    let address = localStorage.getItem("address") || "";
    let phone = localStorage.getItem("phone") || "";
    let splitAddress = doc.splitTextToSize(address, 90);

    let position = 72;
    if (address.length >= 50 && address.length <= 100) {
      position = 75;
    } else if (address.length >= 100 && address.length <= 200) {
      position = 80;
    }

    doc.text(20, 65, splitAddress);
    doc.text(phone, 20, position);
  }

  let img = new Image();

  let baseUrl = localStorage.getItem("base_url");

  if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
    let snapshot = employeeLogo;
    img.src = snapshot;
  } else {
    let snapshot = localStorage.getItem("base_url");
    img.src = snapshot;
  }
  doc.addImage(img, "png", 0, 0, 40, 40);
  jsPDF.autoTableSetDefaults({
    theme: "plain",
    headStyles: { fontStyle: "bold" },

    margin: { left: 8, right: 8, bottom: 10 },
    bodyStyles: { color: "rgba(0, 0, 0, 0.87)", fontStyle: "bold" },
  });
  let col = ["#", "Item", "QTY", "Price", "Total Price"];
  let rows = [];
  let Total = 0;
  let Paid = 0;
  items.forEach((i) => {
    let paid = i.paid ? parseFloat(i.paid) : 0;
    Paid += paid;
    i.items.map((item, index) => {
      let { saleQty, itemPrice, totalPrice } = convertToRFT("", item, "", "");
      Total += parseFloat(totalPrice);
      doc.setFontSize(14);
      let temp = [index + 1, item.name, saleQty, itemPrice, totalPrice];
      rows.push(temp);
    });
  });
  doc.autoTable(col, rows, { startY: 100 });

  let finalY = doc.lastAutoTable.finalY;
  doc.setFontSize(14);
  doc.text("Total", 120, finalY + 16);
  doc.text(Total.toString(), 155, finalY + 16);
  doc.text("Paid", 120, finalY + 26);
  doc.text(Paid.toString(), 155, finalY + 26);
  doc.text("Remaining", 120, finalY + 36);
  doc.text((Total - Paid).toString(), 155, finalY + 36);

  doc.setFontSize(10);
  doc.text("Powered by www.managekaro.pk", 84, 285);
  doc.text("0331 5921209", 95, 290);

  doc.setFontSize(10);
  if (window.innerWidth <= 600) {
    doc.save("reciept");
  } else {
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  }
}

export default ChallanPrint;
